import { makeStyles } from "@material-ui/core";
import { createTheme as createMuiTheme } from "@material-ui/core/styles";
import {
    red,
    green,
    lightBlue,
    orange,
    grey,
    pink,
} from "@material-ui/core/colors";

import color from "color";

export const vars = {
    brandBlue: "#26ade4",
    kpRed: "#de210b",
    active: green[500],
    inactive: grey[500],
    decline: red[500],
};

const UniqTheme = {
    palette: {
        primary: {
            light: color(vars.brandBlue).lighten(0.2).hex(),
            main: vars.brandBlue,
            dark: color(vars.brandBlue).darken(0.2).hex(),
            contrastText: "#FFFFFF",
        },
    },
    typography: {
        fontWeightLight: 300,
        fontWeightRegular: 300,
        fontWeightMedium: 300,
        fontWeightBold: 400,
        button: {
            textTransform: "none",
        },
    },
};

export default createMuiTheme(UniqTheme);

export const viewButtonTheme = createMuiTheme({
    ...UniqTheme,
    palette: {
        primary: {
            main: lightBlue[500],
            contrastText: "#FFFFFF",
        },
    },
});
export const editButtonTheme = createMuiTheme({
    ...UniqTheme,
    palette: {
        primary: {
            main: orange[500],
            contrastText: "#FFFFFF",
        },
    },
});
export const removeButtonTheme = createMuiTheme({
    ...UniqTheme,
    palette: {
        primary: {
            main: red[500],
            contrastText: "#FFFFFF",
        },
    },
});
export const toggleButtonTheme = createMuiTheme({
    ...UniqTheme,
    palette: {
        secondary: {
            main: grey[500],
            contrastText: "#FFFFFF",
        },
        primary: {
            main: green[500],
            contrastText: "#FFFFFF",
        },
    },
});
export const loadExcelButtonTheme = createMuiTheme({
    ...UniqTheme,
    palette: {
        primary: {
            main: green[700],
            contrastText: "#FFFFFF",
        },
    },
});

export const selectHotelButtonTheme = createMuiTheme({
    ...UniqTheme,
    palette: {
        primary: {
            main: pink[700],
            contrastText: "#FFFFFF",
        },
    },
});

export const positioningElems = {
    inlineWithIcon: { position: "relative", bottom: "0.6vh" },
    distanceToIcon: { marginLeft: "0.5rem" },
};

export const useClasses = makeStyles(() => ({
    toggle: {
        borderBottomWidth: "1px",
        borderBottomStyle: "solid",
        borderBottomColor: "transparent",
        userSelect: "none",
        transition: ".3s border-bottom-color",
        fontWeight: "400",

        "&:hover": {
            borderBottomColor: "rgba(0, 0, 0, 0.87)",
            cursor: "pointer",
        },
    },
}));
